import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient.js';
import NewsRow from './NewsRow.jsx';
import { DEFAULT_CONFERENCE_ID, useStateContext } from '../../Contexts/ContextProvider.jsx';
import Loader from '../../assets/tools/Loder/loader';

const News = () => {
  const { SetNotification } = useStateContext();
  const [news, setNews] = useState([]);
  const [filteredNews, setFilteredNews] = useState([]);
  const [loading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [newsPerPage] = useState(5);
  const [conferenceId, setConferenceId] = useState(DEFAULT_CONFERENCE_ID);
  const [language, setLang] = useState('EN');
  const [onDelete , setOnDelete] = useState (false) ; 
  const fetchData = async () => {
    try {
      const response = await AxiosClient.get('/news');
      const _news = response.data.news;
      setNews(_news);
      setIsLoading(false);
    } catch (error) {
      SetNotification('Error fetching data', 'danger');
    }
  };

  useEffect(() => {
    fetchData();
  }, [onDelete]);

  useEffect(() => {
    const filterNews = () => {
      let filtered = news;

      if (conferenceId) {
        filtered = filtered.filter((newsItem) => newsItem.conference_id === conferenceId);
      }

      if (language) {
        filtered = filtered.filter((newsItem) => newsItem.lang === language);
      }

      setFilteredNews(filtered);
    };

    filterNews();
  }, [news, conferenceId, language]);

  const indexOfLastNews = currentPage * newsPerPage;
  const indexOfFirstNews = indexOfLastNews - newsPerPage;
  const currentNews = filteredNews.slice(indexOfFirstNews, indexOfLastNews);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    < div className='p-4'>
      <div className="mb-4">
        <Link className="btn btn-dark" to="./Add">
          <i className="material-icons">add_box</i> Add a New Article
        </Link>
      </div>

      <div className="d-flex align-items-center mb-4">
        <div className="d-flex align-items-center ms-3">
          <label className="me-3 mb-0">Language:</label>
          <button
            className={`btn btn-${language === 'AR' ? 'info' : 'secondary'} me-2`}
            onClick={() => setLang('AR')}
          >
            Arabic
          </button>
          <button
            className={`btn btn-${language === 'EN' ? 'info' : 'secondary'} me-2`}
            onClick={() => setLang('EN')}
          >
            English
          </button>
          {language === 'AR' ? (
            <img src="https://flagsapi.com/IQ/shiny/64.png" alt="Arabic Flag" />
          ) : (
            <img src="https://flagsapi.com/GB/shiny/64.png" alt="English Flag" />
          )}
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          {loading ? (
            <Loader label="Loading news..." />
          ) : (
            <table className="table border w-full table-bordered table-fixed">
              <thead>
                <tr>
                  <th className='w-3/4'>Title</th> 
                  <th></th>
                  <th className='w-1/4'>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentNews.length > 0 ? (
                  currentNews.map((newsItem) => (
                    <NewsRow key={newsItem.id} title={newsItem.title} id={newsItem.id} setOnDelete ={setOnDelete} />
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center">
                      No articles available for this filter.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
        <div className="pagination-container text-center mt-3">
          {filteredNews.length > newsPerPage && (
            <ul className="pagination justify-content-center">
              {Array.from({ length: Math.ceil(filteredNews.length / newsPerPage) }).map((_, index) => (
                <li key={index} className="page-item">
                  <button className="page-link" onClick={() => paginate(index + 1)}>
                    {index + 1}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default News;
